export default "__VITE_ASSET__5WTKboK5__"